var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgELearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#36c;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346,482h-20.73l-15-31h-108.54l-15,31h-20.73c-8.29,0-15,6.71-15,15s6.71,15,15,15h180c8.29,0,15-6.71,15-15s-6.71-15-15-15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316,90c-24.81,0-45,20.19-45,45v108.56c4.69-1.65,9.74-2.56,15-2.56h75V90h-45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m196,90h-45v151h75c5.26,0,10.31.91,15,2.56v-108.56c0-24.81-20.19-45-45-45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,361v15c0,24.81,20.19,45,45,45h422c24.81,0,45-20.19,45-45v-15H0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m467,0H45C20.19,0,0,20.19,0,45v286h512V45c0-24.81-20.19-45-45-45Zm-76,256c0,8.29-6.71,15-15,15h-90c-8.28,0-15,6.72-15,15s-6.71,15-15,15-15-6.71-15-15-6.72-15-15-15h-90c-8.29,0-15-6.71-15-15V75c0-8.29,6.71-15,15-15h60c24.51,0,46.3,11.82,60,30.04,13.7-18.22,35.49-30.04,60-30.04h60c8.29,0,15,6.71,15,15v181Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearning);
export default __webpack_public_path__ + "static/media/e-learning.b321bd9f82dcc05be145284d26706044.svg";
export { ForwardRef as ReactComponent };